import { Package, UserPackage, PackageOffer } from './package.type';

export const getPackages = async () => {
  return await apiClient().get<Package[]>('/packages');
};

export const getUserPackage = async () => {
  const res = await apiClient().get<UserPackage[]>('/listing/user-package');

  return res.data;
};

export const getPackageOffers = async () => {
  return apiClient().get<PackageOffer[]>('/packages/offers/dealer');
};
